import { apiSlice } from "./apiSlice";


export const designEngineeringDashboardSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({

        getDesignKpis: builder.query({
            query: (projectId) => {
                const url = `/DesignTracker/kpi`;
                if (projectId) {
                    const params = new URLSearchParams();
                    params.set("projectId", projectId);
                    return {
                        url: `${url}?${params.toString()}`,
                        method: "GET",
                    }
                }
                return url
            }
        }),

        getDesignIEStatusKpis: builder.query({
            query: (projectId) => {
                const url = `/DesignTracker/iekpi`;
                if (projectId) {
                    const params = new URLSearchParams();
                    params.set("projectId", projectId);
                    return {
                        url: `${url}?${params.toString()}`,
                        method: "GET",
                    }
                }
                return url
            }
        }),

        getDesignKpiApprovals: builder.query({
            query: ({ projectId }) => {
                const params = new URLSearchParams();
                params.set("projectId", projectId)
                return {
                    url: `/DesignTracker/kpi/approvals?${params.toString()}`,
                    method: "GET"
                }
            },
        }),

        getDesignKpiAvgApprovalTime: builder.query({
            query: ({ projectId }) => {
                const params = new URLSearchParams();
                params.set("projectId", projectId)
                return {
                    url: `/DesignTracker/kpi/avg-approval-time?${params.toString()}`,
                    method: "GET"
                }
            },
        }),

        getDesignKpiAgeing: builder.query({
            query: ({ projectId }) => {
                const params = new URLSearchParams();
                params.set("projectId", projectId)
                return {
                    url: `/DesignTracker/kpi/ageing?${params.toString()}`,
                    method: "GET"
                }
            },
        }),

        getDesignKpiComponents: builder.query({
            query: ({ projectId }) => {
                const params = new URLSearchParams();
                params.set("projectId", projectId)
                return {
                    url: `/DesignTracker/kpi/components?${params.toString()}`,
                    method: "GET"
                }
            },
        }),

        getDesignEngCriticalDrawingCount: builder.query({
            query: (params) => ({
                url: `DesignTracker/ucdcount`,
                params,
            }),
        }),

        getDesignEngCriticalDrawingListByDays: builder.query({
            query: (params) => ({
                url: `DesignTracker/missed-ucdlist`,
                params,
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
        }),
        getDesignEngKpiDrillDown: builder.query({
            query: (params) => ({
                url: `DesignTracker/kpi/drilldown`,
                params,
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
        }),
        getDesignEngKpiAgeingDrillDown: builder.query({
            query: (params) => ({
                url: `DesignTracker/kpi/ageing/drilldown`,
                params,
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
        }),

        getDesignEngIEStatusKpiDrillDown: builder.query({
            query: (params) => ({
                url: `DesignTracker/iekpi/drilldown`,
                params,
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
        }),

        getDesignEngDrawingSummary: builder.query({
            query: (params) => ({
                url: `DesignTracker/kpi/drawingsummary`,
                params,
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
        }),
    })
})



export const {
    useGetDesignKpisQuery,
    useGetDesignIEStatusKpisQuery,
    useGetDesignKpiApprovalsQuery,
    useGetDesignKpiAvgApprovalTimeQuery,
    useGetDesignKpiAgeingQuery,
    useGetDesignKpiComponentsQuery,
    useGetDesignEngCriticalDrawingCountQuery,
    useGetDesignEngCriticalDrawingListByDaysQuery,
    useGetDesignEngKpiDrillDownQuery,
    useLazyGetDesignEngKpiDrillDownQuery,
    useGetDesignEngKpiAgeingDrillDownQuery,
    useGetDesignEngIEStatusKpiDrillDownQuery,
    useGetDesignEngDrawingSummaryQuery
} = designEngineeringDashboardSlice